export default "__VITE_ASSET__WVYsQ0SM__"